module.exports = __webpack_public_path__ + "img/ic_chat_btn_set.26969d2f.svg";